var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"breadcrumbs\" ng-init=\"setRoute([\r\n  {page:'service_list', title: 'Set a Service'},\r\n  {page:'person_list', title: 'Pick a Person'},\r\n  {page:'day', title: 'Select a Date'}\r\n  ])\">\n<ol class=\"breadcrumb\">\n<li ng-repeat=\"step in bb.allSteps\" ng-class=\"{'active': step.active, 'passed': step.passed, 'disabled': isDisabledStep(step)}\">\n<button type=\"button\" ng-click=\"loadStep(step.number)\" ng-class=\"{'active': step.active, 'passed': step.passed}\" ng-disabled=\"isDisabledStep(step)\">\n<span class=\"step-num\">{{step.number}}.</span>\n<span class=\"step-title\">{{step.title}}</span>\n</button>\n</li>\n</ol>\n</div>";
var id1="public-booking/breadcrumb/breadcrumb_complex.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/breadcrumb/breadcrumb_complex.html
// module id = 1216
// module chunks = 0